import * as React from 'react';

const SvgUploadOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M13.037 10.836V21h-2V10.829l-3.585 3.585L6.04 13l5.998-6 6.002 6.033-1.418 1.41-3.584-3.607Z", fill: "currentColor" }),
    React.createElement("path", { d: "M8 17v2H2V3h20v16h-6v-2h4V5H4v12h4Z", fill: "currentColor" })));

export { SvgUploadOutline as default };
